import { gql } from 'graphql-request'

export const TOGGLE_WRITING_DISABLED = gql`
  mutation ToggleWritingDisabled($userId: Int!) {
    toggleWritingDisabled(userId: $userId)
  }
`
